<template>
    <div>
        <left-nav :drawer="drawer" :user="user" :systemConfig="systemConfig" @navStateChanged="syncDrawer"></left-nav>
        <toolbar v-on:toggleNav="toggleNav" :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig"></toolbar>
        <toast></toast>
        <router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig"></router-view>
    </div>
</template>

<script>
  import Toolbar from '@/views/app/elements/Toolbar'
  import LeftNav from '@/views/app/elements/LeftNav'
  import Toast from '@/views/app/elements/Toast'
  import {SystemConfigMixin} from '@/views/mixins'

  export default {
    name: 'system-root',
    components: {Toolbar, LeftNav, Toast},
    mixins: [SystemConfigMixin],
    data () {
      return {
        drawer: null
      }
    },
    created () {},
    computed: {
      firebaseUser () {
        return this.$firebaseClient.firebaseUser
      },
      user () {
        return this.$firebaseClient.user
      }
    },
    methods: {
      toggleNav () {
        this.drawer = !this.drawer
        console.log('Toggling Nav')
      },
      syncDrawer (state) {
        if (this.drawer !== state) {
          console.log('Drawer is out of sync')
          this.drawer = state
        }
      }
    },
    beforeDestroy () {
    }
  }
</script>

<style lang="scss">
</style>
